'use client';

import { useEffect, useState } from 'react';
import { PageContentProps } from './types/propsTypes';
import { getContentEssentials } from 'utils/getEssentials';

const usePageContent = ({
  initialData,
  locale,
  uId,
  queryUrl,
  fallbackQueryUrl,
  enableFlag,
  userType,
}: PageContentProps) => {
  const [pageContent, setPageContent] = useState({ data: initialData, hasError: false, notFound: false });

  const fetchWithQueryUrl = async (queryUrlToUse: string) =>
    await getContentEssentials({
      locale,
      uId: uId,
      params: [
        {
          key: 'query',
          value: JSON.stringify({
            url: queryUrlToUse,
            ...(enableFlag && {
              'account_types.account_types': { $in: [userType] },
            }),
          }),
        },
      ],
    });

  const fetchPageContent = async () => {
    let { data, showError } = await fetchWithQueryUrl(queryUrl);

    const needsFallback = showError || !Object.keys(data || {}).length;

    if (needsFallback && fallbackQueryUrl && fallbackQueryUrl !== queryUrl) {
      const fallbackResponse = await fetchWithQueryUrl(fallbackQueryUrl);
      ({ data, showError } = fallbackResponse);
    }

    if (showError) {
      setPageContent({ data: {}, hasError: true, notFound: false });
    } else if (!Object.keys(data).length) {
      setPageContent({ data: {}, hasError: false, notFound: true });
    } else {
      setPageContent({ data, hasError: false, notFound: false });
    }
  };

  useEffect(() => {
    if (!initialData || !Object.keys(initialData)?.length) {
      fetchPageContent();
    } else {
      setPageContent({ data: initialData, hasError: false, notFound: false });
    }
  }, [initialData]);

  return pageContent;
};

export default usePageContent;
